class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    
    // Mengaktifkan hover (mouseenter) pada desktop
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    
    // Pasang mouseleave di elemen terluar (.header-wrapper) sekali saja
    if (this.header && !this.header.dataset.mouseleaveBound) {
      this.header.dataset.mouseleaveBound = 'true';
      this.header.addEventListener('mouseleave', () => {
        if (window.innerWidth > 990) {
          document.querySelectorAll('header-menu').forEach((menu) => menu.close());
        }
      });

      // Tutup mega menu ketika mouse menyentuh link menu biasa (yang bukan header-menu)
      const inlineMenu = document.querySelector('.header__inline-menu');
      if (inlineMenu) {
        inlineMenu.addEventListener('mouseover', (e) => {
          if (window.innerWidth > 990) {
            const target = e.target.closest('a');
            if (target && !target.closest('header-menu')) {
              document.querySelectorAll('header-menu').forEach((menu) => menu.close());
            }
          }
        });
      }
    }
    
    // Mencegah klik summary menutup menu secara tidak sengaja di desktop, tapi tetap mengizinkan navigasi jika berupa link
    const summary = this.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', (e) => {
        if (window.innerWidth > 990) {
          e.stopPropagation(); // Mencegah event bubbling ke global listener yang bisa memicu penutupan menu
          
          // Ambil URL dari data-attribute atau dari tag link (a)
          const targetUrl = summary.getAttribute('data-url') || (e.target.closest('a') || summary.querySelector('a') || {}).href;
          if (targetUrl && targetUrl !== '#') {
            window.location.href = targetUrl;
          }
          // Cegah toggle default <details> agar popup menu tidak tertutup sebelum berpindah halaman
          e.preventDefault();
        }
      });
    }
  }

  onMouseEnter() {
    if (window.innerWidth > 990) {
      // Tutup menu lain yang sedang terbuka saat masuk ke menu baru
      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this) menu.close();
      });

      this.mainDetailsToggle.setAttribute('open', '');
      var summary = this.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', true);
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
